import styled from "@emotion/styled";
export const StyledGlobeMobileHomepageFirstFoldComponent = styled.div`
  .globe-text-and-asset-content {
    .image-wrapper {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
`;
